import React, {ReactNode, useEffect, useState} from 'react'
import {Box} from '@mui/material'
import FooterDisclaimer from './FooterDisclaimer'
import HeaderBar from './HeaderBar'
import MobileDrawer from './MobileDrawer'
import SideNav from './SideNav'
import {NavItemConfig} from './types'

interface AppShellNewProps {
  navItems: NavItemConfig[]
  children: ReactNode
}

const AppShellNew = ({navItems, children}: AppShellNewProps): JSX.Element => {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [sidebarExpanded, setSidebarExpanded] = useState(
    () => localStorage.getItem('ia-sidebar-expanded') !== 'false'
  )

  useEffect(() => {
    localStorage.setItem('ia-sidebar-expanded', String(sidebarExpanded))
  }, [sidebarExpanded])

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {xs: '1fr', md: 'auto 1fr'},
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <Box sx={{display: {xs: 'none', md: 'block'}, height: '100%', overflow: 'hidden'}}>
        <SideNav
          expanded={sidebarExpanded}
          onToggle={() => setSidebarExpanded(v => !v)}
          navItems={navItems}
        />
      </Box>

      <MobileDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        navItems={navItems}
      />

      <Box sx={{display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden', minWidth: 0}}>
        <HeaderBar navItems={navItems} onMenuClick={() => setDrawerOpen(true)} />
        <Box sx={{flex: 1, overflowY: 'auto', px: {xs: 2, md: 4}, py: 2}}>{children}</Box>
        <FooterDisclaimer />
      </Box>
    </Box>
  )
}

export default AppShellNew
